module.exports = __webpack_public_path__ + "static/media/logo-anatomia.3e248f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-anatomia.png
// module id = 2136
// module chunks = 1